import React from 'react'
import './styles.css' // Import the CSS file for styling
import FixWidthContainer from '../../atoms/fixWidthContainer'
import Spacer from '../../atoms/Spacer'
import review from '../../../assets/img/review.png'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // Import carousel styles
import borboleta1 from '../../../assets/img/borboleta_1.png'
import borboleta2 from '../../../assets/img/borboleta_2.png'
import borboleta3 from '../../../assets/img/borboleta_3.png'
import borboleta4 from '../../../assets/img/borboleta_4.png'

const reviews = [
  {
    text:
      'Dra Gabriela é uma pediatra INCRÍVEL! Super humanizada com a criança e com os pais! Sensível, atenciosa e até para chamar atenção da gente (os pais) é com gentileza! Eu e minha filha amamos! ',
    rating: 5,
    author: 'Núbia Marcelle',
  },
  {
    text:
      'A Dra. Gabriela é uma excelente profissional, pediatra atualizada com atendimento humanizado. Nos sentimos acolhidos no atendimento da nossa filha.',
    rating: 5,
    author: 'Camila Barone',
  },
  {
    text:
      'Gabi sempre muito atenciosa! Passa muita tranquilidade e segurança nas consultas, deixando o puerperio muito mais leve !❤️',
    rating: 5,
    author: 'Laura Campos',
  },
]

const redirectToGoogle = () => {
  window.open('https://www.google.com/maps/place/Gabriela+Pinheiro+-+Pediatra/@-19.9293615,-43.9654113,17z/data=!4m8!3m7!1s0xa697149dfdab53:0xbb6cf59bfcb4e856!8m2!3d-19.9293615!4d-43.9654113!9m1!1b1!16s%2Fg%2F11j0tbrx7k?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D', '_blank')
}

const Review = () => {
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    }
  }, [])

  return (
    <>
      {isMobile ? (
        <div
          className="review-wrapper"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            margin: '0 auto',
            padding: '0 0',
          }}
        >
          <img
            src={review}
            alt="review"
            className="review-image"
            style={{
              position: 'absolute',
              top: 55,
              right: 110,
              height: 160,
            }}
          />
          <FixWidthContainer justifyContent="center" alignItems="center">
            <Spacer size={200} />
            <div className="review-container">
            <h2 className="depoimentos" onClick={redirectToGoogle}>Avaliações</h2>
              <Carousel
                showArrows={false} // Hides the arrow buttons
                showThumbs={false} // Hides the small thumbnail images
                showStatus={false} // Hides the status (e.g. 1/3)
                infiniteLoop={true} // Enables infinite loop
                autoPlay={true} // Automatically plays
                interval={5000} // Time interval for auto-play
                transitionTime={500} // Animation transition time
                stopOnHover={true} // Stops auto-play on hover
                swipeable={true} // Enables swipe functionality
                emulateTouch={true} // Makes it more touch-friendly
                className="review-items-carousel"
              >
                {reviews.map((review, index) => (
                  <div key={index} className="review-item">
                    <div className="review-stars">
                      {Array.from({ length: 5 }).map((_, starIndex) => (
                        <span
                          key={starIndex}
                          className={
                            starIndex < review.rating ? 'star filled' : 'star'
                          }
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    <p>{review.text}</p>
                    {/* <p className="review-author">- {review.author}</p> */}
                  </div>
                ))}
              </Carousel>
              {/* Navigation buttons for mobile */}
            </div>
          </FixWidthContainer>
        </div>
      ) : (
        <div style={{ position: 'relative' }}>
          <img
            style={{
              position: 'absolute',
              top: -1000,
              right: 100,
              zIndex: 1,
              height: 45,
              width: 45,
              transform: 'rotate(49deg)',
            }}
            src={borboleta2}
            alt="borboleta1"
          />
          <img
            style={{
              position: 'absolute',
              top: 60,
              right: 130,
              zIndex: 1,
              height: 30,
              width: 30,
              // transform: 'rotate(deg)',
            }}
            alt="borboleta0"
            src={borboleta1}
          />
          <img
            style={{
              position: 'absolute',
              top: -300,
              right: 125,
              height: 95,
              width: 95,
              // transform: 'rotate(deg)',
            }}
            alt="borboleta2"
            src={borboleta2}
          />
          <img
            style={{
              position: 'absolute',
              top: 0,
              left: 30,
              zIndex: 1,
              height: 60,
              width: 60,
            }}
            src={borboleta4}
            alt="borboleta4"
          />
          <Spacer size={60} />
          <img
            src={review}
            alt="review"
            style={{
              position: 'absolute',
              top: '160px', // Adjust as needed to control overlap amount
              left: '85%',
              transform: 'translateX(-50%)',
              height: '270px',
            }}
          />
          <FixWidthContainer>
            <Spacer size={80} />
              <div className="review-container">

              <h2 className="depoimentos" onClick={redirectToGoogle}>Avaliações</h2>

              <div className="review-items-container">
                {reviews.map((review, index) => (
                  <div key={index} className="review-item">
                    <div className="review-stars">
                      {Array.from({ length: 5 }).map((_, starIndex) => (
                        <span
                          key={starIndex}
                          className={
                            starIndex < review.rating ? 'star filled' : 'star'
                          }
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    <p>{review.text}</p>
                    {/* <p className="review-author">- {review.author}</p> */}
                  </div>
                ))}
              </div>
            </div>
          </FixWidthContainer>
          <Spacer size={60} />
        </div>
      )}
    </>
  )
}

export default Review
